import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

function Failed() {
  const navigate = useNavigate()

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Jost', sans-serif",
      backgroundColor: '#faf8f5',
      padding: '40px 20px',
    }}>

      {/* X icon */}
      <div style={{
        width: '72px',
        height: '72px',
        borderRadius: '50%',
        border: '1.5px solid #9b8575',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '32px',
        color: '#9b8575',
      }}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </div>

      {/* Title */}
      <h1 style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: '2.4rem',
        fontWeight: 400,
        color: '#3a2218',
        margin: '0 0 12px 0',
        letterSpacing: '0.02em',
        textAlign: 'center',
      }}>
        გადახდა ვერ მოხერხდა
      </h1>

      {/* Subtitle */}
      <p style={{
        fontSize: '0.72rem',
        fontWeight: 300,
        letterSpacing: '0.15em',
        color: '#9b8575',
        textTransform: 'uppercase',
        margin: '0 0 48px 0',
        textAlign: 'center',
      }}>
        გთხოვთ სცადოთ თავიდან
      </p>

      {/* Divider */}
      <div style={{
        width: '48px',
        height: '1px',
        backgroundColor: '#e0d8cf',
        marginBottom: '48px',
      }} />

      {/* Buttons */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'center' }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: '#3a2218',
            border: '1px solid #3a2218',
            color: '#f7f4ef',
            fontFamily: "'Jost', sans-serif",
            fontSize: '0.68rem',
            letterSpacing: '0.25em',
            textTransform: 'uppercase',
            fontWeight: 300,
            padding: '14px 36px',
            cursor: 'pointer',
            transition: 'all 0.25s ease',
            minWidth: '260px',
          }}
          onMouseEnter={e => e.target.style.background = '#5c3d2e'}
          onMouseLeave={e => e.target.style.background = '#3a2218'}
        >
          თავიდან ცდა
        </button>

        <button
          onClick={() => navigate('/')}
          style={{
            background: 'none',
            border: '1px solid #e0d8cf',
            color: '#9b8575',
            fontFamily: "'Jost', sans-serif",
            fontSize: '0.68rem',
            letterSpacing: '0.25em',
            textTransform: 'uppercase',
            fontWeight: 300,
            padding: '14px 36px',
            cursor: 'pointer',
            transition: 'all 0.25s ease',
            minWidth: '260px',
          }}
          onMouseEnter={e => {
            e.target.style.borderColor = '#9b8575'
            e.target.style.color = '#3a2218'
          }}
          onMouseLeave={e => {
            e.target.style.borderColor = '#e0d8cf'
            e.target.style.color = '#9b8575'
          }}
        >
          მთავარ გვერდზე დაბრუნება
        </button>
      </div>

    </div>
  )
}

export default Failed